import React from 'react';
import {Icon} from "semantic-ui-react";

const BeerIcons = ({beerPunishment}) => (
    <div className="beerIcons">
        {beerPunishment ? [...Array(4)].map((n, index) =>
            <Icon
                key={index}
                name='beer'
                color={beerPunishment <= index ? 'grey' : 'black'}
                inverted={beerPunishment <= index}/>) : null}
    </div>);

export default BeerIcons;



// WEBPACK FOOTER //
// ./src/Components/BeerIcons.js